import { QUESTION_TYPE } from '@components/dynamic-form/dynamic-form.validation';

type YesNoAnswer = {
  [key: string]: string;
};

const yesNoAnswerMap: YesNoAnswer = {
  true: 'Yes',
  false: 'No',
};

type NprFormatDeps = {
  questionsById: Record<number, { questionTypeId?: number; questionName?: string }>;
  nprQuestionIdByName: Record<string, number>;
};

// STORE FORMAT --> RHF FORMAT (getNpr)
// convert API answer obj to internal RHF answer format
// returns the RHF object used in the NPR RHF
export const formatNprRhfAnswers = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formData: any,
  deps: NprFormatDeps
) => {
  const { questionsById, nprQuestionIdByName } = deps;

  const rhfDefaultValues: { [key: string]: string | boolean | undefined } = {};
  const nprData = formData?.request?.noPermitRequireds?.[0] ?? {};
  const nprTypes = ['npr', 'ex'];

  Object.keys(nprData).map((key) => {
    const type = key.split('_')[0];
    let val = nprData[key];

    if (!nprTypes.includes(type)) {
      rhfDefaultValues[key] = val;
      return;
    }

    // Fetch question data for questionName
    const questionId = nprQuestionIdByName[key];
    const questionData = questionsById[questionId];

    if (!questionId || !questionData) {
      rhfDefaultValues[key] = val;
      return;
    }

    // Format values
    if (questionData?.questionTypeId === QUESTION_TYPE.yesNo) {
      if (nprData[key] === 'Yes') {
        val = true;
      }
      if (nprData[key] === 'No') {
        val = false;
      }
    }

    if (questionData?.questionTypeId === QUESTION_TYPE.option) {
      if (nprData[key] === 'N/a') {
        val = 'Not Applicable';
      }
    }

    if (questionData?.questionName) {
      rhfDefaultValues[questionData.questionName] = val;
    } else {
      rhfDefaultValues[key] = val;
    }
  });
  return rhfDefaultValues;
};

// STORE FORMAT --> API FORMAT (updateNPR)
// convert internal answer obj to API answer format sent in the update request
// returns the No Permit Required payload object used in the updateNPR endpoint
export const formatNprAnswerSet = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formData: any,
  deps: NprFormatDeps
) => {
  const { questionsById, nprQuestionIdByName } = deps;
  const nprData = formData?.request?.noPermitRequireds?.[0] ?? {};
  const formattedObj: YesNoAnswer = {};
  const nprTypes = ['npr', 'ex'];

  Object.keys(nprData).map((key) => {
    const type = key.split('_')[0];
    let val = nprData[key];

    if (nprTypes.includes(type)) {
      // Fetch question data for questionName
      const questionId = nprQuestionIdByName[key];
      const questionData = questionsById[questionId];

      // Format values
      if (questionData?.questionTypeId === QUESTION_TYPE.yesNo) {
        val = typeof nprData[key] === 'boolean' ? yesNoAnswerMap[String(nprData[key])] : nprData[key];
      }
      if (questionData?.questionTypeId === QUESTION_TYPE.option) {
        val = nprData[key] === 'Not Applicable' ? 'N/a' : nprData[key];
      }
    }
    formattedObj[key] = val;
  });

  formData.request.noPermitRequireds = [formattedObj];
  return formData;
};
